<template>
      <div class="tabs">
            <div class="tabs-bar">
                <!--标题页的标题 v-for遍历, :class 动态绑定class-->
                <div :class="tabCls(item)" v-for="(item,index) in navList" :key="index" @mousemove="handleChange(index)">
                    <router-link :to="'/list/'+item.link">
                    {{item.label}}
                    </router-link>
                </div>
            </div>
            <div class="tabs-content">
                <!--这里的slot就是嵌套的pane组件的内容-->
                <slot></slot>
            </div>
        </div>
</template>

<script>
export default {
    name:'tabs',
     props: {
        //接收父组件的value
        value: {
            type: [Number]
        }
    },
    data(){
        return{
            navList:[],
            currentValue: this.value
        }
    },
    methods:{
        getTabs() {
            return this.$children.filter((item)=> {
                return item.$options.name === 'pane';
            })
        },
        //更新tabs
        updateNav() {
            this.navList = [];
            this.getTabs().forEach((pane, index)=>{
                this.navList.push({
                    label: pane.label,
                    name: pane.name || index,
                    link:pane.link||''
                });
                //如果没有设置name，默认设置为索引值
                if(!pane.name) {
                    pane.name = index;
                }
                //设置第一个pane为当前显示的tab
                if(index === 0) {
                    if(!this.currentValue) {
                        this.currentValue = pane.name || index;
                    }
                }
            });
            this.updateStatus();
        },
        updateStatus() {
            var tabs = this.getTabs();
            //显示当前选中的tab对应的pane组件，隐藏没有选中的
            tabs.forEach((tab)=> {
                return tab.show = tab.name === this.currentValue;
            })
        },
        tabCls: function(item) {
            return [
                'tabs-tab',
                {
                    //为当前选中的tab加一个tabs-tab-active class
                    'tabs-tab-active': item.name === this.currentValue
                }
            ]
        },
        //点击tab标题触发
        handleChange(index) {
            var nav = this.navList[index];
            var name = nav.name;
            //改变当前选中的tab，触发watch
            this.currentValue = name;
            //实现子组件与父组件通信
            this.$emit('input', name);
        }
    },
     watch: {
        value: function(val) {
            this.currentValue = val;
        },
        currentValue: function() {
            //tab发生变化时，更新pane的显示状态
            this.updateStatus();
        }
    }

}
</script>

<style lang="scss">
.tabs{
    .tabs-bar{
        border-bottom: 1px solid $primary;
        padding-bottom: 8px;
        .tabs-tab{
            cursor: pointer;
             background-image: url(~@/assets/images/titleBg.jpg);
           border-radius: 6px;
        background-repeat: repeat-x;
        display: inline-block;
            color: white;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            margin-right: 10px;
            padding: 0 12px;
            &.tabs-tab-active{
                color: white;
                opacity: 1;
                 background-image: url(~@/assets/images/titleBg2.jpg);
                
            }
        }
        .tabs-content{
            .pane{

            }
        }
    }

}

</style>
